import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const NRTFormContainer = (props) => {

    return (

        <div className={'nrt-form-container ' + props.className} style={props.style}>

            <div className={'form'} style={props.formStyle}>
                {
                    !!props.title &&
                    <h3>{props.title}</h3>
                }

                {!!props.title && <hr/>}

                {props.children}
            </div>
        </div>
    )
}


NRTFormContainer.propTypes = {
    title: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    formStyle: PropTypes.object,
}

NRTFormContainer.defaultProps = {
    style: {} ,
    formStyle: {} ,
    className: '',
}


export default NRTFormContainer



// WEBPACK FOOTER //
// ./src/components/_common/_form/_containers/FormContainer/index.js